import PropTypes from 'prop-types';
import * as React from 'react';
import ListComponent from './list-component';

export default class ListContainer extends React.Component {
  render() {
    return (
      <ListComponent
        loading={this.props.loading}
        loadingText={this.props.loadingText}
        children={this.props.children} />
    );
  }
}

ListComponent.propTypes = {
  error: PropTypes.bool,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/component/list/list-container.js